import React from 'react'
import FlightSlugBanner from './FlightSlugBanner'

export default function FlightSlug() {
    return (
        <>
            <FlightSlugBanner />

        </>
    )
}
